import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import 'next/stylesheets/components/identity-verifier.scss';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { matches } from 'next/javascripts/modules/dom';

Component('tr-identity-verifier', {
  mixins: [eventListenerMixin],

  properties: {
    supportVerifierMethods: String,
    currentVerifierMethod: {
      type: String,
      observer() {
        this.changeVerifierMethod();
      },
    },
    passStatus: {
      type: Boolean,
      default: false,
      observer() {
        this.changePassStatus();
      },
    },
  },

  ready() {
    this.listenTo(this.querySelector('.verifier-methods'), 'click', this.handleVerfiierMethodsClick.bind(this));
    $(this).on('ajax:success', this.handleVerifierResult.bind(this));
    this.listenTo(this, 'tr-wechat-qrcode-verifier:success', this.handleWechatVerifierResult.bind(this));
    this.appendForm();
  },

  disconnected() {
    this.stopListening();
  },

  appendForm() {
    const template = this.querySelector(`#${this.currentVerifierMethod}-verifier-form`);
    const comtainer = this.querySelector('.verifier-form');
    const form = template.content.cloneNode(true);
    $(comtainer).empty();
    comtainer.appendChild(form);
    if (this.currentVerifierMethod === 'mobile') {
      this.initMobileVerificationForm();
    }
  },

  handleVerfiierMethodsClick(e) {
    if (e.target && matches(e.target, 'span.verifier-method')) {
      this.setCurrentVerfierMethod(e.target.dataset.method);
    }
  },

  setCurrentVerfierMethod(method) {
    this.currentVerifierMethod = method;
    this.querySelector('.verifier-methods').dataset.currentMethod = method;
  },

  changeVerifierMethod() {
    this.appendForm();
    this.namespacedTrigger('changed', { bubbles: true });
  },

  handleVerifierResult(e, result) {
    if (matches(e.target, '.mobile-verifier-form,.password-verifier-form')) {
      if (result.success) {
        this.passStatus = true;
      } else {
        this.passStatus = false;
      }
    }
  },

  handleWechatVerifierResult() {
    this.namespacedTrigger('success', { bubbles: true });
  },

  initMobileVerificationForm() {
    const mobileVerifierForm = this.querySelector('.mobile-verifier-form');
    if (mobileVerifierForm && mobileVerifierForm.length > 0) {
      window.tower.initMobileVerification($(mobileVerifierForm));
    }
  },

  changePassStatus() {
    if (this.passStatus) {
      this.namespacedTrigger('success', { bubbles: true });
    } else {
      this.namespacedTrigger('fail', { bubbles: true });
    }
  },
});
